import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";

import uuid from "react-uuid";

import { makeStyles } from "@mui/styles";
import {
  AutocompleteInput,
  CustomSelect,
  CustomSwitch,
  DateInput,
  FloatInput,
  IntInput,
  LocalizationAutocomplete,
  TextInput,
} from "components/Input/Index.js";

import CreateButton from "components/CustomButtons/CreateButton.js";

import { compte } from "variables/patrimoine.js";

import AdvancedSearchContext from "context/AdvancedSearchContext";
import {utilitytypebyenergy} from "variables/lists/authorization";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { login } from "assets/img/login.jpeg";
import {  updateAccountMeter,getFiles,getAccountContracts,getAccountDsos,getAPIAuthorizationList } from "services/ConfigServices";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function AddUserDialog(props) {
  const currentusertype = localStorage.getItem('userType');

  const [authorizationData, setAuthorizationData] = useState([]);
  const [utilityauthorizationData, setUtilityauthorizationData] = useState([]);
  const [prevData, setPrevData] = useState();
  const [clef, setClef] = useState();
  const [meternumber, setMeternumber] = useState();
  const [serialnumber, setSerialnumber] = useState();
  const [name, setName] = useState();
  const [options, setOptions] = useState([]);
  const [validatedAddress, setValidatedAddress] = useState({});
  const loaded = useRef(false);
  const [status, setStatus] = useState("");
  const [address, setAddress] = useState({});
  const [inputValue, setInputValue] = useState("");
  const [metersDso, setMetersDso] = useState("");
  const [diameter, setDiameter] = useState("");
  const [acheminement, setAcheminement] = useState();
  const [monthlyconsumption, setMonthlyconsumption] = useState(false);
  const [dailyconsumption, setDailyconsumption] = useState(false);
  const [loadcurve, setloadcurve] = useState(false);
  const [contractualdata, setContractualdata] = useState(false);
  const [associatedcontractid, setAssociatedcontractid] = useState("");
  const [comments, setComments] = useState();
  const [description, setDescription] = useState();
  const [authorizationid, setAuthorizationid] = useState();
  const [usagecode, setUsagecode] = useState();
  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  const [ged, setGed] = useState([]);
  const [utilitiesData, setUtilitiesData] = useState([]);
  const [dsoData, setDsoData] = useState([]);
  const [utilitydata, setUtilitydata] = useState(false);
  const [utilityauthorizationid, setUtilityauthorizationid] = useState();

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const { closeModal, refetch, energy, parameters, deleteCounter } = props;

  const handleClefChange = (e) => {
    setClef(e.target.value);
  };
  const handleMeternumberChange = (e) => {
    setMeternumber(e.target.value);
  };
  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };
  const handleSerialnumberChange = (e) => {
    setSerialnumber(e.target.value);
  };
  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleDsoChange = (e) => {
    setMetersDso(e.target.value);
  };
  const handleDiameterChange = (e) => {
    setDiameter(e.target.value);
  };
  const handleAcheminementChange = (e) => {
    setAcheminement(e.target.value);
  };
  const handleMonthlyconsumptionChange = (e) => {
    setMonthlyconsumption(!monthlyconsumption);
  };
  const handleDailyconsumptionChange = (e) => {
    setDailyconsumption(!dailyconsumption);
  };
  const handleLoadcurveChange = (e) => {
    setloadcurve(!loadcurve);
  };
  const handleContractualdataChange = (e) => {
    setContractualdata(!contractualdata);
  };
  const handleAssociatedfilesChange = (newValue) => {
    setGed(newValue);
  };
  const handleAssociatedcontractidChange = (e) => {
    setAssociatedcontractid(e.target.value);
  };
  const handleCommentsChange = (e) => {
    setComments(e.target.value);
  };
  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };
  const handleAuthorizationidChange = (e) => {
    setAuthorizationid(e.target.value);
  };
  const handleUsagecodeChange = (e) => {
    setUsagecode(e.target.value);
  };
  const handleUtilityauthorizationidChange = (e) => {
    setUtilityauthorizationid(e.target.value);
  };
  const handleUtilitydataChange = (e) => {
    setUtilitydata(!utilitydata);
  };
  const selectedGed = () => {
    let gedCardId = [];
    let getGedNames;

    if (ged !== undefined) {
      for (let i = 0; i < ged.length; i++) {
        gedCardId.push(ged[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };

  useEffect(() => {
    axios
    .get(
      getAPIAuthorizationList(chartIdGroup),
      {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      }
    )
    .then((res) => {
      let tmpAuthorizationData = res.data.authorizations?.filter((data) => data.energy===energy).map((data) => {
        return (
            { name: data.legalname + " (" + data.dateend + ")", id: data.id }
          );
      });
      setAuthorizationData(
        tmpAuthorizationData || []
      );
      let tmpUtilityauthorizationData = res.data.authorizations?.filter((data) => (data.energy === energy || data.energy ==='multiple') && utilitytypebyenergy[energy].includes(data.type)).map((data) => {
        return (
          { name: data.legalname + " (" + data.dateend + ")", id: data.id }
        );
      });
      setUtilityauthorizationData(
        tmpUtilityauthorizationData || []
      );
    });
  }, []);

  useEffect(() => {
    axios
      .get(
        getFiles(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        getAccountDsos(chartIdGroup, energy),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        let tmpDsoData = res.data.dsos?.map((data) => {
          return (
            { name: data.details.name, id: data.uuid }
          );
        });
        setDsoData(tmpDsoData);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        getAccountContracts(chartIdGroup, energy),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        let tmpUtilitiesData = res.data.contracts?.map((data) => {
          return (
            { name: data.details.contractnumber + " (" + data.details.name + ")", id: data.uuid }
          );
        });
        setUtilitiesData(tmpUtilitiesData);
      });
  }, []);

  const handleSubmit = async (event) => {
    const editedDetails = {
      clef,
      status,
      serialnumber,
      name,
      address,
      validatedAddress,
      dso: metersDso,
      diameter,
      acheminement,
      monthlyconsumption,
      dailyconsumption,
      loadcurve,
      contractualdata,
      utilitydata,
      associatedcontractid,
      ged,
      comments,
      description,
      authorizationid,
      utilityauthorizationid,
      usagecode,
    };

    const editedMeter = {
      meternumber,
      'uuid': uuid(),
      details : editedDetails,
    };

    axios
      .post(
        updateAccountMeter(editedMeter.uuid,chartIdGroup,energy),
        editedMeter,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then(() => {
        closeModal();
        refetch();
        deleteCounter();
      })
      .catch(() => { });
  };

  const statusData = [
    { name: "Actif", id: "on" },
    { name: "Résilié", id: "off" },
  ];


  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].key}
                textInput={clef}
                handleTextInputChange={handleClefChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].meternumber}
                textInput={meternumber}
                handleTextInputChange={handleMeternumberChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={compte.energy[energy][parameters].status}
                selectValue={status}
                handleSelectValueChange={handleStatusChange}
                data={statusData}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].serialnumber}
                textInput={serialnumber}
                handleTextInputChange={handleSerialnumberChange}
              />
            </div>
            <div>
              <LocalizationAutocomplete
                specialWidth={"97%"}
                inputTitle={compte.energy[energy][parameters].address}
                value={address}
                setValue={setAddress}
                setValidatedAddress={setValidatedAddress}
                validatedAddress={validatedAddress}
                inputValue={inputValue}
                setInputValue={setInputValue}
                options={options}
                setOptions={setOptions}
                loaded={loaded}
              />
            </div>
            <div>
              <IntInput
                inputTitle={compte.energy[energy][parameters].diameter}
                intInput={diameter}
                handleIntInputChange={handleDiameterChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].acheminement}
                textInput={acheminement}
                handleTextInputChange={handleAcheminementChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={
                  compte.energy[energy][parameters].monthlyconsumption
                }
                checkedState={monthlyconsumption}
                handleSwitchChange={handleMonthlyconsumptionChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={compte.energy[energy][parameters].dailyconsumption}
                checkedState={dailyconsumption}
                handleSwitchChange={handleDailyconsumptionChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={compte.energy[energy][parameters].loadcurve}
                checkedState={loadcurve}
                handleSwitchChange={handleLoadcurveChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={compte.energy[energy][parameters].contractualdata}
                checkedState={contractualdata}
                handleSwitchChange={handleContractualdataChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={compte.energy[energy][parameters].utilitydata}
                checkedState={utilitydata}
                handleSwitchChange={handleUtilitydataChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={
                  compte.energy[energy][parameters].dso
                }
                selectValue={metersDso}
                handleSelectValueChange={handleDsoChange}
                data={dsoData}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={
                  compte.energy[energy][parameters].associatedcontractid
                }
                selectValue={associatedcontractid}
                handleSelectValueChange={handleAssociatedcontractidChange}
                data={utilitiesData}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={
                  compte.energy[energy][parameters].authorization
                }
                selectValue={authorizationid}
                handleSelectValueChange={handleAuthorizationidChange}
                data={authorizationData}
              />
            </div>
            {currentusertype == 1 &&
              <>
                <div>
                  <CustomSelect
                    inputTitle={
                      compte.energy[energy][parameters].utilityauthorization
                    }
                    selectValue={utilityauthorizationid}
                    handleSelectValueChange={handleUtilityauthorizationidChange}
                    data={utilityauthorizationData}
                  />
                </div>
              </>
            }
            <div>
              <AutocompleteInput
                specialWidth="97%"
                inputTitle={compte.energy[energy][parameters].associatedfiles}
                selected={selectedGed()}
                list={gedList}
                handleChange={(_, newValue) =>
                  handleAssociatedfilesChange(newValue)
                }
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].comments}
                textInput={comments}
                handleTextInputChange={handleCommentsChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].usagecode}
                textInput={usagecode}
                handleTextInputChange={handleUsagecodeChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <CreateButton buttonDisabled={false} handleSubmit={handleSubmit} />
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}></GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default AddUserDialog;
